// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class QuickFiltersService {
   appState: any
   beyondHoldings: any
   config: any
   eBooksFacet: any
   events: any
   i18n: any
   includeMatchesInFullText: any
   inclusiveFilters: any
   institutionFacet: any
   printBooksFacet: any
   scope: any
   utils: any
   searchScopeService: SearchScopeService
   constructor(configService: any, appState: any, utils: any, events: any, i18n: any, searchScopeService: SearchScopeService) {
      this.isPhysicalOrEbook = this.isPhysicalOrEbook.bind(this)
      this.handlePhysicalAndEbook = this.handlePhysicalAndEbook.bind(this)
      this.disableFacet = this.disableFacet.bind(this)
      this.enableFacet = this.enableFacet.bind(this)
      this.update = this.update.bind(this)
      this.isApplied = this.isApplied.bind(this)
      this.remove = this.remove.bind(this)
      this.add = this.add.bind(this)
      this.toggle = this.toggle.bind(this)
      this.getFilterClasses = this.getFilterClasses.bind(this)
      this.createFilter = this.createFilter.bind(this)
      this.filters = this.filters.bind(this)
      this.appState = appState
      this.utils = utils
      this.events = events
      this.i18n = i18n
      this.config = configService.data
      this.scope = {
         filters: [],
         combinedFilters: [],       // combination of filter of refine panel and advanced search. So 'selected fields' will be shown even if shoudn't be shown in refine panel. 
         applied: false,
         activeFilters: [],
         enabled: this.config.quickFilters.enabled
      }
      // Inclusive filter for Institution was move as myinst param.
      this.inclusiveFilters = []
      this.institutionFacet = 'Institution'
      this.printBooksFacet = 'print.books.only'
      this.eBooksFacet = 'ebooks.only'
      this.beyondHoldings = 'ho'
      this.includeMatchesInFullText = 'include.ft.matches'
      this.appState.on('apply', () => {
         return this.update()
      })
      this.searchScopeService = searchScopeService
   }

   isPhysicalOrEbook(filter: any) {
      return (filter.facet === this.printBooksFacet) || (filter.facet === this.eBooksFacet)
   }

   handlePhysicalAndEbook() {
      // check if @printBooksFacet & @eBooksFacet are not both applied...
      const printBookFilter = _.find(this.scope.filters, (f: any) => f.facet === this.printBooksFacet)
      const ebookFilter = _.find(this.scope.filters, (f: any) => f.facet === this.eBooksFacet)
      if (!printBookFilter || !ebookFilter) {
         // if they're not enabled both, we can ignore the following code
         return
      }

      if ((printBookFilter && printBookFilter.applied) && (ebookFilter && ebookFilter.applied)) {
         // removes the ebookfilter... (TODO should we notify user somehow?)
         ebookFilter.applied = false
         ebookFilter.disabled = true
         // and remove from appstate (note that this does not update URL ...) TODO update URL?
         delete this.appState.params[this.eBooksFacet]
      } else if (ebookFilter && ebookFilter.applied && printBookFilter) {
         printBookFilter.disabled = true
         ebookFilter.disabled = false
         printBookFilter.applied = false
      } else if (printBookFilter && printBookFilter.applied && ebookFilter) {
         ebookFilter.disabled = true
         printBookFilter.disabled = false
         ebookFilter.applied = false
      } else {
         ebookFilter.disabled = false
         printBookFilter.disabled = false
      }

      // and set tooltips
      if (printBookFilter && ebookFilter) {
         printBookFilter.tooltip = this.i18n.translate(this.i18n.translations.QUICKFILTER_REMOVE_OTHER_X, { facet: this.i18n.translations.EBOOK_FULL_TEXT_ONLINE })
         return ebookFilter.tooltip = this.i18n.translate(this.i18n.translations.QUICKFILTER_REMOVE_OTHER_X, { facet: this.i18n.translations.PHYSICAL_BOOKS_LIBRARY_CATALOG })
      }
   }

   disableFacet(facet: any) {
      const foundFacet = _(this.scope.filters).find((f: any) => f.facet === facet)
      if (foundFacet) {
         return foundFacet.disabled = true
      }
   }

   enableFacet(facet: any) {
      const foundFacet = _(this.scope.filters).find((f: any) => f.facet === facet)
      if (foundFacet) {
         return foundFacet.disabled = false
      }
   }

   update() {
      this.scope.filters = this.filters(false)
      this.scope.combinedFilters = this.filters(true)    // Combine filters of 'Refine your search' both from facet panel and adv. search. Used for selection pane. In case selected items from adv. search are not enabled in regular search, it will still appear as selected
      this.handlePhysicalAndEbook()
      this.scope.applied = _(this.scope.combinedFilters).any((f: any) => f.applied)
      return this.scope.activeFilters = _(this.scope.combinedFilters).filter((f: any) => f.applied)
   }

   // filter value representation for api
   facetValue(filter: any) {
      return `${filter.facet},${this.utils.summonEscape(filter.value)},f`
   }

   isApplied(filter: any): boolean {
      return this.isAppliedBy(filter, this.appState.params) || this.isAppliedBy(filter, this.appState.searchScopeParams)
   }

   isAppliedBy(filter: any, params: any) : boolean {
      if(!params){
         return false
      }
      
      if (this.inclusiveFilters.includes(filter.facet)) {
         return _(params.fvfi).contains(this.facetValue(filter))
      } else if (filter.facet === this.institutionFacet) {
         return params.myinst === filter.value
      } else if (filter.facet === this.printBooksFacet) {
         return params[this.printBooksFacet] === filter.value
      } else if (filter.facet === this.eBooksFacet) {
         return params[this.eBooksFacet] === filter.value
      } else if (filter.facet === this.beyondHoldings) {
         return (params[this.beyondHoldings] === filter.value) || (params[this.beyondHoldings] === false)
      } else if (filter.facet === this.includeMatchesInFullText) {
         if ((params[this.includeMatchesInFullText] !== true) || filter.defaultInclusion) {
            return false
         } else { return true }
      } else {
         return _(params.fvf).contains(this.facetValue(filter))
      }
   }

   remove(filter: any) {
      if (this.inclusiveFilters.includes(filter.facet)) {
         return this.appState.params.fvfi = _(this.appState.params.fvfi).reject((f: any) => f === this.facetValue(filter))
      } else if (filter.facet === this.includeMatchesInFullText) {
         return this.appState.params[this.includeMatchesInFullText] = 'f'
      } else if (filter.facet === this.institutionFacet) {
         return this.appState.params.myinst = ''
      } else if (filter.facet === this.beyondHoldings) {
         return this.appState.params[this.beyondHoldings] = 't'
      } else if (filter.facet === this.printBooksFacet) {
         delete this.appState.params[this.printBooksFacet]
         this.enableFacet(this.printBooksFacet)
         return this.enableFacet(this.eBooksFacet)
      } else if (filter.facet === this.eBooksFacet) {
         delete this.appState.params[this.eBooksFacet]
         this.enableFacet(this.eBooksFacet)
         return this.enableFacet(this.printBooksFacet)
      } else {
         return this.appState.params.fvf = _(this.appState.params.fvf).reject((f: any) => f === this.facetValue(filter))
      }
   }

   add(filter: any) {
      this.remove(filter)
      if (this.inclusiveFilters.includes(filter.facet)) {
         return this.appState.params.fvfi.push(this.facetValue(filter))
      } else if (filter.facet === this.includeMatchesInFullText) {
         return this.appState.params[this.includeMatchesInFullText] = 't'
      } else if (filter.facet === this.institutionFacet) {
         return this.appState.params.myinst = filter.value
      } else if (filter.facet === this.beyondHoldings) {
         return this.appState.params[this.beyondHoldings] = filter.value
      } else if (filter.facet === this.printBooksFacet) {
         this.appState.params[this.printBooksFacet] = filter.value
         delete this.appState.params[this.eBooksFacet]
         return this.disableFacet(this.eBooksFacet)
      } else if (filter.facet === this.eBooksFacet) {
         this.appState.params[this.eBooksFacet] = filter.value
         delete this.appState.params[this.printBooksFacet]
         return this.disableFacet(this.printBooksFacet)
      } else {
         return this.appState.params.fvf.push(this.facetValue(filter))
      }
   }

   toggle(filter: any) {
      if (filter?.disabled) {
         return
      }
      filter.applied = !filter.applied
      if (filter.facet === this.includeMatchesInFullText) {
         filter.value = !filter.value
      }
      if(filter.fromSearchScope){
         filter.applied = true
         this.searchScopeService.clearScopeAsSideEffect()
         return
      }
      const setState = () => {
         this.appState.params.pn = 1
         if (!this.isApplied(filter)) {
            this.add(filter)
            return this.events.gaPush("refinements", "add", filter.label)
         } else {
            this.remove(filter)
            return this.events.gaPush("refinements", "remove", filter.label)
         }
      }

      return this.appState.applyStateWithSnapShot(setState)
   }

   getFilterClasses(filter: any) {
      return {
         applied: filter.applied,
         disabledFacet: filter.disabled
      }
   }

   createFilter(props: any) {
      const filter = _.clone(props)
      filter.applied = this.isApplied(filter)
      filter.fromSearchScope = this.isAppliedBy(filter, this.appState.searchScopeParams)
      return filter
   }

   /**
    * Refine panel filters: apply filters according to config.
    * @param isCombined 
    * true -> set true to retrive active filters (for selection pane). Both filters will be combined: refine panel + adv. search refine. 
    *         So in case filters from set in adv. search are not set in refine panel, they will still be shown in selections pane. 
    * false -> set false to get the list of filters in refine panel (not combined with adv. search) 
    * @returns array of filters (combined/not-combined with adv. search filters). Set for each filter if it is applied or not.
    */
   filters(isCombined = false) {
      const scopeFilter = isCombined ? this.scope.combinedFilters : this.scope.filters

      if (scopeFilter.length === 0) {
         // create filters based on configuration
         const quickFilters = isCombined ? this.combineFilters(this.config.quickFilters.filters, this.config.quickFilters.advancedFilters) : this.config.quickFilters.filters
         return quickFilters.map((qf: any) => {
            return this.createFilter(qf)
         })
      }
      else {
         scopeFilter.forEach((qf: any) => {
            qf.applied = this.isApplied(qf)
            qf.fromSearchScope = this.isAppliedBy(qf, this.appState.searchScopeParams)
         })
         return scopeFilter
      }
   }

   combineFilters(filters: any, advancedFilters: any) {
      const combinedFilters = [...filters]
      advancedFilters.map((filter: any) => {
         // Check if facet exists already in combinedFilter
         if (!combinedFilters.some(item => item.facet == filter.facet)) {
            combinedFilters.push(filter)
         }
      })
      return combinedFilters
   }
}
QuickFiltersService.$inject = ['configService', 'appStateService', 'utilitiesService', 'eventService', 'translationService', 'searchScopeService']

angular.module('summonApp.services')
   .service('quickFiltersService', QuickFiltersService)
